import * as R from 'ramda'

export const ticketStatus: {
  [key: string]: string;
} = {
  PROCESSING: 'Processing',
  EXPIRED: 'Expired',
  COMPLETE: 'Complete'
}

export const ticketStatusKeys = R.keys(ticketStatus)
export const ticketStatusValues = R.values(ticketStatus)

export const ticketPriority: {
  [key: string]: string;
} = {
  IMPORTANT: 'Important',
  GENERAL: 'General',
  UNIMPORTANT: 'Unimportant'
}

export const ticketPriorityKeys = R.keys(ticketStatus)
export const ticketPriorityValues = R.values(ticketStatus)

export const codesMap: { [ key: string ]: string } = {
  '0200': 'NEW',
  '0201': 'EDIT',
  '0202': 'EDIT_NAME',
  '0203': 'EDIT_EXPECTED_TIME',
  '0204': 'EDIT_CONTENT',
  '0205': 'DELETE',
  '0210': 'CLOSE',
  '0211': 'COMPLETE',
  '0212': 'COMMENT',
  '0213': 'UPDATE_ASSIGNEES',
  '0215': 'UPDATE_SUPERVISORS',
  '0217': 'UPDATE_RELATED_TICKETS',
  '0219': 'UPDATE_LABELS',
  '0221': 'CHANGE_PRIORITY',
  '0222': 'EDIT_COMMENT',
  '0223': 'REOPEN',
  '0224': 'REPROCESS'
}
